const setIndex = (state, obj) => {
    if (state.maxIndex != obj.zIndex) {
        state.maxIndex = obj.zIndex = state.maxIndex + 1
    }
}
export const dialogCont = {
    namespaced: true,
    state: () => (
        {
            maxIndex: 3001,
            dialogCallInfo: {
                zIndex: 3000,
                show: false,
                position: {
                    "left": '100px',
                    "top": '100px',
                    "right": 'auto',
                    "bottom": 'auto',
                }
            },
            dialogAiChatInfo: {
                zIndex: 3000,
                show: false,
                position: {
                    "left": 'auto',
                    "top": 'auto',
                    "right": '100px',
                    "bottom": '100px',
                }
            },
            dialogWxChatInfo: {
                zIndex: 3000,
                show: false,
                curUserUnreadNum: 0,
                curAllUserUnreadNum: 0,
                openType: 1,  // 1 直接打开主窗口  2 老师列表打开
                wxid: null,
                uuid: null,
                chatToUser: {
                    user_name: null,
                    nick_name: null,
                    sysWxWebId: null,
                },
                position: {
                    "left": 'auto',
                    "top": 'auto',
                    "right": '100px',
                    "bottom": '100px',
                }
            },
        }
    ),
    getters: {

    },
    mutations: {
        dialogCallInfoChange(state, val) {
            state.dialogCallInfo = { ...state.dialogCallInfo, ...val }
            setIndex(state, state.dialogCallInfo)
        },
        dialogAiChatInfoChange(state, val) {
            state.dialogAiChatInfo = {
                ...state.dialogAiChatInfo,
                ...val
            }
            setIndex(state, state.dialogAiChatInfo)
        },   
        dialogWxChatInfoChange(state, val) {
            state.dialogWxChatInfo = {
                ...state.dialogWxChatInfo,
                ...val
            }
            setIndex(state, state.dialogWxChatInfo)
        },  
    },
    actions: {

    },
}